import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useModelInfo } from '../../../../common/ModelInfoContext';
import makeCancellable from '../../../../common/makeCancellable';
import fetchFeatures from '../../../../api/fetchFeatures';
import fetchCapabilities from '../../../../api/fetchCapabilities';
import fetchModelMatrix from '../../../../api/fetchModelMatrix';
import LoadingSpecsCompare from '../../../../common/loading/LoadingSpecsCompare';

const FetchTrimFeatureCompare = ({
  render,
  postalCode,
  includeCapabilities,
  config,
}) => {
  const [features, setFeatures] = useState(null);
  const [capabilities, setCapabilities] = useState(null);
  const [modelMatrix, setModelMatrix] = useState(null);
  const modelInfo = useModelInfo();

  useEffect(() => {
    const { cancel, promise } = makeCancellable(
      fetchFeatures({ ...modelInfo, postalCode })
    );
    promise
      .then((features) => {
        setFeatures(features);
      })
      .catch((err) => {});

    let cancelCapabilities = null;
    let cancelModelMatrix = null;

    if (includeCapabilities) {
      const { cancel, promise: capabilitiesPromise } = makeCancellable(
        fetchCapabilities(modelInfo)
      );
      cancelCapabilities = cancel;
      capabilitiesPromise
        .then((capabilitiesData) => setCapabilities(capabilitiesData))
        .catch((err) => {});

      const { cancel: cancel2, promise: modelMatrixPromise } = makeCancellable(
        fetchModelMatrix({ ...modelInfo, config })
      );
      cancelModelMatrix = cancel2;
      modelMatrixPromise
        .then((modelMatrixData) => setModelMatrix(modelMatrixData))
        .catch((err) => {});
    }

    return () => {
      cancel();
      cancelCapabilities && cancelCapabilities();
      cancelModelMatrix && cancelModelMatrix();
    };
  }, []);

  return features && (!includeCapabilities || (modelMatrix && capabilities)) ? (
    render({ features, capabilities, modelMatrix })
  ) : (
    <LoadingSpecsCompare />
  );
};

FetchTrimFeatureCompare.propTypes = {
  postalCode: PropTypes.string.isRequired,
  render: PropTypes.func.isRequired,
};

export default FetchTrimFeatureCompare;
